import React, { useCallback, useEffect, useRef, useState } from 'react';
import TextEditor from '../../../../components/serverDrivenUIComponents/TextEditor';
import { Heading } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';
import { Star } from '../../../../UiKit/Star/Star';
import { Button, Input } from '@grofers/react';
import Multiselect from 'multiselect-react-dropdown';
import './form.css';
import { useCreateAnnouncements } from './apis';
import Spinner from 'sushiweb/Spinner/Spinner';
import { convertLocalDateTimeToUtc } from '../../../../utils/UtilFunctions';

const styles = {
  mutliSelectRolesDesign: `
      div:first-child() {
        width: 100%;
      }
      #multiselectContainerReact
        > div.optionListContainer.displayNone {
        display: none !important;
        z-index: 20 !important;
        position: absolute !important;
        margin-top: 2rem !important;
      }
    `,
  multiSelectOrganisationDesign: `div:first-child() {
      width: 100%;
    }
    #multiselectContainerReact
      > div.optionListContainer.displayNone {
      display: none !important;
      z-index: 20 !important;
      position: absolute !important;
      margin-top: 2rem !important;
    }
    .icon_down_dir {
      position: absolute;
      right: 1.5rem;
      z-index: 30;
      top: auto;
      transform: none;
    }`,
};

const CreateForm = (props) => {
  const {
    getPermissionsList,
    permissionsLoading,
    refetchAnnouncements,
    getOrganisationsList,
    organisationsLoading,
  } = props;
  const [formDataToSubmit, setFormDataToSubmit] = useState();
  const multiselectRef = useRef();
  const {
    mutate,
    isLoading: isSubmitting,
    isSuccess,
  } = useCreateAnnouncements();

  const handleFormData = useCallback(
    (inputKey, value) => {
      const formData = { ...formDataToSubmit, [inputKey]: value };
      setFormDataToSubmit(formData);
    },
    [formDataToSubmit],
  );

  useEffect(() => {
    if (isSuccess) {
      refetchAnnouncements();
      setFormDataToSubmit({});
      document.getElementById('create_announcement_form').reset();
      setFormDataToSubmit({ announcement_text: '' });
      multiselectRef.current.resetSelectedValues();
    }
  }, [isSuccess, refetchAnnouncements]);

  const saveOptions = useCallback(
    (selectedList, selectedItem) => {
      setFormDataToSubmit({ ...formDataToSubmit, roles: selectedList });
    },
    [formDataToSubmit],
  );

  const removeOptions = useCallback(
    (selectedList, removedItem) => {
      setFormDataToSubmit({ ...formDataToSubmit, roles: selectedList });
    },
    [formDataToSubmit],
  );

  const saveOrganizationOption = useCallback(
    (selectedList, selectedItem) => {
      setFormDataToSubmit({
        ...formDataToSubmit,
        org_id: selectedItem.id,
      });
    },
    [formDataToSubmit],
  );

  const removeOrganizationOption = useCallback(
    (selectedList, removedItem) => {
      setFormDataToSubmit({
        ...formDataToSubmit,
        org_id: null,
      });
    },
    [formDataToSubmit],
  );

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      mutate(formDataToSubmit);
    },
    [formDataToSubmit, mutate],
  );

  const isValid = () => {
    const isAllField =
      formDataToSubmit?.announcement_text?.length &&
      formDataToSubmit?.start_ts &&
      formDataToSubmit?.end_ts &&
      formDataToSubmit?.roles?.length;
    return isAllField ? true : false;
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-4'>
      <div className='tw-font-semibold tw-text-800 tw-text-base-green tw-gap-2'>
        <span>Create Announcements</span>
      </div>
      <form
        className='tw-bg-white tw-p-8 tw-rounded-2xl tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-6 tw-relative tw-h-full'
        id='create_announcement_form'
      >
        <label
          htmlFor='ann_text_editor'
          className='tw-w-full tw-flex tw-flex-col tw-gap-1'
        >
          <div>
            <Heading
              title={'Announcement Text'}
              color='#1F1F1F'
              weight='600'
              size='17px'
            />

            <Star icon='*' />
          </div>
          <TextEditor
            styleClasses='tw-w-full tw-flex tw-flex-wrap tw-text-wrap'
            id='ann_text_editor'
            inputKey={'announcement_text'}
            field={{ value: formDataToSubmit?.announcement_text }}
            saveOptions={handleFormData}
          />
        </label>
        <div className='tw-w-full tw-flex tw-gap-2 tw-justify-evenly'>
          <div className='tw-w-1/3'>
            <label
              htmlFor='customerIdInput'
              className='tw-w-full tw-flex tw-flex-col tw-gap-1'
            >
              <div>
                <Heading
                  title={'Start Timestamp'}
                  color='#1F1F1F'
                  weight='600'
                  size='17px'
                />

                <Star icon='*' />
              </div>
              <Input
                style={{
                  padding: '1.22rem 1rem',
                  fontWeight: '400',
                  fontSize: '1.33rem',
                }}
                type='datetime-local'
                onChange={(e) => {
                  handleFormData(
                    'start_ts',
                    convertLocalDateTimeToUtc(e.target.value),
                  );
                }}
              />
            </label>
          </div>
          <div className='tw-w-1/3'>
            <label
              htmlFor='customerIdInput'
              className='tw-w-full tw-flex tw-flex-col tw-gap-1'
            >
              <div>
                <Heading
                  title={'End Timestamp'}
                  color='#1F1F1F'
                  weight='600'
                  size='17px'
                />

                <Star icon='*' />
              </div>
              <Input
                style={{
                  padding: '1.22rem 1rem',
                  fontWeight: '400',
                  fontSize: '1.33rem',
                }}
                type='datetime-local'
                onChange={(e) => {
                  handleFormData(
                    'end_ts',
                    convertLocalDateTimeToUtc(e.target.value),
                  );
                }}
              />
            </label>
          </div>
          <div className='tw-w-1/3 '>
            <label
              htmlFor='customerIdInput'
              className='tw-w-full tw-flex tw-flex-col tw-gap-1'
              css={styles.mutliSelectRolesDesign}
            >
              <div>
                <Heading
                  title={'Roles'}
                  color='#1F1F1F'
                  weight='600'
                  size='17px'
                />
                <Star icon='*' />
              </div>
              <Multiselect
                showCheckbox
                ref={multiselectRef}
                avoidHighlightFirstOption
                singleSelect={false}
                loading={permissionsLoading}
                placeholder='Search roles...'
                options={getPermissionsList}
                onSelect={saveOptions}
                onRemove={removeOptions}
                displayValue='name'
              />
            </label>
          </div>
          <div className='tw-w-1/3 '>
            <label
              htmlFor='customerIdInput'
              className='tw-w-full tw-flex tw-flex-col tw-gap-1'
              css={styles.multiSelectOrganisationDesign}
            >
              <div>
                <Heading
                  title={'Organization'}
                  color='#1F1F1F'
                  weight='600'
                  size='17px'
                />
                <Star icon='*' />
              </div>
              <Multiselect
                showCheckbox
                ref={multiselectRef}
                avoidHighlightFirstOption
                singleSelect={true}
                loading={organisationsLoading}
                placeholder='Search organizations...'
                options={getOrganisationsList}
                onSelect={saveOrganizationOption}
                onRemove={removeOrganizationOption}
                displayValue='name'
              />
            </label>
          </div>
        </div>
        <div className='tw-flex tw-justify-between tw-w-full'>
          <Button
            onClick={handleSubmit}
            size='medium'
            variant='fill'
            style={{ padding: '1rem 1.7rem' }}
            disabled={!isValid(formDataToSubmit)}
            className='tw-h-14 tw-w-28 tw-mt-4 '
          >
            {isSubmitting ? (
              <Spinner size='small' color={`${grey.z300}`} />
            ) : (
              'Submit'
            )}
          </Button>
          <div className='tw-flex tw-items-center tw-gap-2'>
            <div
              className='tw-flex tw-items-center tw-justify-center'
              css={`
                & p {
                  margin-bottom: 0 !important;
                }
              `}
            >
              <Heading
                title={'Enable/Disable'}
                color='#1F1F1F'
                weight='600'
                size='17px'
              />
            </div>
            <label className='switch tw-flex tw-gap-1'>
              <input
                type='checkbox'
                onChange={(e) => {
                  handleFormData('is_enabled', e.target.checked);
                }}
                defaultChecked={false}
              />
              <span className='slider round'></span>
            </label>
          </div>
        </div>
      </form>
    </div>
  );
};
export default CreateForm;
